import { Component, OnInit, inject } from "@angular/core";
import { ViewportService } from "src/app/shared/services/viewport.service";
import { ZzzConfigService } from "src/app/zzz/core/config/config.service";
import { AccueilPesComponent } from "./pes/accueil-pes.component";
import { AccueilIntranetComponent } from "./intranet/accueil-intranet.component";
import { CommonModule } from "@angular/common";
import { BandeauAvisComponent } from "./bandeau-avis/bandeau-avis.component";

@Component({
    templateUrl: './accueil.component.html',
    styleUrls: ['./accueil.component.scss'],
    imports: [
        CommonModule,
        AccueilPesComponent,
        AccueilIntranetComponent,
        BandeauAvisComponent
    ]
})
export class AccueilComponent implements OnInit {
  #configService = inject(ZzzConfigService);
  #viewportService = inject(ViewportService);

  estIntranet = this.#configService.get().estIntranet;

  ngOnInit(): void {
    this.#viewportService.setDefaultViewport();
  }
}
